import React, { useState} from 'react';
import {makeStyles} from "@mui/styles";
import {IconButton, Theme} from "@mui/material";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {IntegrationItemProps} from "../../api/integrations/IntegrationsDTO";
import {useHistory} from "react-router";
import {useIntegrationsContext} from "../../api/integrations/IntegrationsContext";
import {toast} from "react-toastify";
import {showError} from "../../utils/NotificationUtils";
import cx from "classnames"
import {DialogWindow} from '../ui/DialogWindow';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        background: "#ffffff",
        boxShadow: theme.shadows[1],
        padding: "16px 24px",
        borderRadius: 10,
        marginBottom: 16,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "&.deleted": {
            display: "none"
        }
    },
    itemInfo: {
        display: "flex",
        alignItems: "center",
        gap: 20
    },
    itemLogo: {
        width: 40,
        height: 40,
        border: "1px solid #CACACA",
        borderRadius: 5,
        padding: 2,
        "& img": {
            width: "100%",
            height: "100%",
            objectFit: "contain"
        }
    },
    itemTitle: {
        cursor: "pointer"
    },
    itemActions: {}
}));

interface Props {
    readonly data: IntegrationItemProps
}

export function IntegrationListItem({data}: Props) {
    const classes = useStyles();
    const history = useHistory();
    const [showDialog, setShowDialog] = useState(false);
    const {IntegrationsApi} = useIntegrationsContext();
    const [deleted, setDeleted] = useState(false);

    const onDelete = () => {
        IntegrationsApi.deleteIntegration({data: {id: data.id}}).then(() => {
            toast.success("Deleted");
            setShowDialog(false);
            setDeleted(true)
        }).catch(err => {
            showError(err)
        })
    }

    return (
        <>
            <li className={cx(classes.root, {deleted})}>
                <div className={classes.itemInfo}>
                    <div className={classes.itemLogo}>
                        <img src={data.logoUrl} alt=""/>
                    </div>
                    <div>
                        <h3 className={classes.itemTitle} onClick={() => {
                            history.push("integration/editor/" + data.id + "/authentication")
                        }}>{data.name}</h3>
                    </div>
                </div>
                <div className={classes.itemActions}>
                    <IconButton onClick={() => {
                        setShowDialog(true)
                    }}>
                        <DeleteOutlineIcon color="error"/>
                    </IconButton>
                </div>
            </li>
            <DialogWindow
                warningMessage="DELETE_INTEGRATION_WARNING"
                show={showDialog}
                onClose={() => setShowDialog(false)}
                onCancel={() => console.log("hello")}
                onAgree={onDelete}>
                Are you sure?
            </DialogWindow>
        </>
    );
}

